import request from '../utils/request.js'

/**
 * 购物车商品列表
 * **/
export function getNewUserGoods() {
  return request({
    url: process.env.SALEURL + "/api/newUserGoods",
    method: 'get'
  })
}


/**
 * 确认收下10元优惠券
 * **/
export function newUserBindCoupon() {
  return request({
    url: process.env.SALEURL + "/api/newUserBindCoupon",
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/newcomersList.js